import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { browserHistory, Redirect } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Warning from '../../../components/Warning2';

import SelectionTab from './../../../components/ZUILib/SelectionTab';
import InputButton from './../../../components/ZUILib/InputButton';
import EventTable from './components/EventTable';
import { NextArrowWap } from './components/NextBackArrowsWap';
import ApplyCSS from './../../../components/ApplyCSS';
import AppEvents from '../../App/AppEvents';

import commonUtil from '../../../utils/commonUtil';
import GiftListConfigureWapModal from '../../eventManagement/page/GiftList/wapComponents/GiftListConfigureWapModal';
import * as searchEventActions from '../SearchEvent/actions';
import { ReorderListBtn } from './components/ReorderListBtn';
import JSONDATA from '../SearchEvent/searchEvents';
import MonthRangePicker from './../../../components/ZUILib/MonthRangePicker';
import { eventType } from '../../../utils/clientConstant';
import * as labelsActions from '../../../components/labels/actions';
import * as EventCategoryActions from "../../../components/eventcategory/actions";
import _ from 'lodash';
const months = [
  { name: "Ene", value: 0 },
  { name: "Feb", value: 1 },
  { name: "Mar", value: 2 },
  { name: "Abr", value: 3 },
  { name: "May", value: 4 },
  { name: "Jun", value: 5 },
  { name: "Jul", value: 6 },
  { name: "Ago", value: 7 },
  { name: "Sep", value: 8 },
  { name: "Oct", value: 9 },
  { name: "Nov", value: 10 },
  { name: "Dic", value: 11 },
];
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const { isLablesLoaded, loadLables } = labelsActions;
const { eventSearchByUserDetails, addAllEventSearchByUserDetails, cleanSearchByUserDetails } = searchEventActions;
const channel = commonUtil.getChannel();
const isWebDevice = (channel === 'web');
const pageName = 'searchTable';
const applicationRoutes = commonUtil.getApplicationRoutes();

const resultsPerPage = 30;
const typeOrderProp = ['asc', 'desc'];
@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isEventCategoryLoaded(getState())) {
      return dispatch(loadEventCategoryEvent());
    }
    return undefined;
  },
},
])
class SearchResult extends Component {
  constructor(props) {
    super(props);
    const filterProductSearchResult = this.props.filterProductSearchResult || {};
    const userFirstName = filterProductSearchResult.firstNameOrNickName || '';
    const userMotherName = filterProductSearchResult.motherName || '';
    const userLastName = filterProductSearchResult.lastNameOrPaternalName || '';
    const eventTypeSelectTab = filterProductSearchResult.eventType || '';
    const eventDateEndRange = filterProductSearchResult.eventDateEndRange;
    const eventDateStartRange = filterProductSearchResult.eventDateStartRange;

    this.lastName = '';
    this.firstName = '';
    this.montherName = '';
    this.activeIndex = 0;
    this.typeOfTable = [];
    this.calenderDate = '';
    this.appliedFilter = [];
    this.isReorder = false;
    this.productsArray = [];
    this.eventTypeFilter = '';
    this.calenderDateValue = '';
    this.wapBackButtonEvent = null;
    this.userLastName = userLastName;
    this.userFirstName = userFirstName;
    this.userMotherName = userMotherName;
    this.eventDateEndRange = eventDateEndRange;
    this.eventDateStartRange = eventDateStartRange;

    this.dataForEventSearchByUserDetails = {
      firstNameOrNickName: userFirstName,
      lastNameOrPaternalName: userLastName,
      motherName: userMotherName,
      eventDateEndRange,
      eventDateStartRange,
      pageNum: '1',
      resultsPerPage,
      eventType : this.props.filterProductSearchResult?.eventType
    };
    this.isFiltering = false;
    this.scrollObserverRef = React.createRef();
    this.state = {
      MonthRangePicker: false,
      startDate: this.props.filterProductSearchResult.eventDateStartRange || "",
      endDate: this.props.filterProductSearchResult.eventDateEndRange || "",
      startMonthName: this.getMonthNameAndYear(this.props.filterProductSearchResult.eventDateStartRange) || '',
      endMonthName: this.getMonthNameAndYear(this.props.filterProductSearchResult.eventDateEndRange) || '',
      shareModal: false,
      eventDateStartRange,
      eventDateEndRange,
      eventTypeSelectTab: !!eventTypeSelectTab,
      gifthList: [],
      filterTypeEventOrder: false,
      pageNum: "1",
      eventDateSort: "asc",
      isLoadingMore: false,
      wapEventType: this.props.filterProductSearchResult.eventType || "",
      showScrollIcon:false
    };
  }

  getMonthNameAndYear = (date) => {
    if (date) {
      const startMonth = new Date(date).getMonth();
      const startYear = new Date(date).getFullYear();

      const startMonthName = months.find((i) => i.value === startMonth)?.name;

      if (startMonthName && startYear) {
        return `${startMonthName}-${startYear}`
      } else {
        return ''
      }
    }

  }
  changeEvetDateSort = (option) => {
    const eventSearchByUserDetailsFn = this.props.eventSearchByUserDetails || function () { };
    eventSearchByUserDetailsFn({
      ...this.dataForEventSearchByUserDetails,
      eventDateSort: option.id,
    });
    this.setState({ eventDateSort: option.id })
  }

  componentDidMount() {
    
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }
    commonUtil.addTransition();

    const results = this.props.filterProductSearchResult.totalResultsMatchedCount;
    if(commonUtil.getChannel() === "wap" && this.props.filterProductSearchResult.events?.length == '1'){
                browserHistory.push(applicationRoutes.searchEvent)
    }
    const dataLayer = {
      event: 'comprar_para_mesa_de_regalos',
      seccion: 'Mesa de regalos',
      phase: 'Busqueda de mesa',
      step: 'Llegada resultados',
      results,
    };
    window.dataLayer.push(dataLayer);

    if (this.scrollObserverRef && this.scrollObserverRef.current) {
      this.observer = new IntersectionObserver(
        entries => {
          const [entry] = entries;
          if (entry.isIntersecting && !this.state.isLoadingMore) {
            this.loadMoreOnScroll();
          }
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1.0,
        }
      );

      this.observer.observe(this.scrollObserverRef.current);
    }
      window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    const { extraData } = this.props;

    if (
      extraData.length > 0 &&
      prevProps.extraData.length === 0 && // or !== current, depending on logic
      this.scrollObserverRef?.current
    ) {
      console.log("Products rendered — re-attaching observer");

      // Delay slightly to ensure DOM is painted
      setTimeout(() => {
        this.observer?.observe(this.scrollObserverRef.current);
      }, 2000);
    }
  }

  componentWillMount() {
    const props = this.props;
    const filterProductSearch = props.filterProductSearchResult || {};
    const productPerPageOfPagination = props.productPerPageOfPagination;
    const events = filterProductSearch.events || null;
    const eventTypes = filterProductSearch.eventTypes || [];
    const filterProductSearchResult = events;

    if (filterProductSearchResult) {
      this.productsArray = this.getProductPerPage(filterProductSearchResult, productPerPageOfPagination);
      if (eventTypes.length <= 0) {
        this.typeOfTable = [
          ...new Set(
            filterProductSearchResult.map(
              item => item.eventType),
          )].map(event => ({ value: event }));
      } else {
        const aditionalEventType = [...eventTypes, 'Todos los eventos'];
        this.typeOfTable = aditionalEventType.map(event => ({ value: event }));
      }
    } else if (browserHistory) {
      this.redirectNoStore();
    }

    if (filterProductSearchResult) {
      this.updateListOfEvents(filterProductSearchResult);
      return;
    }
    this.redirectNoStore();
  }

  componentWillUnmount() {
    if (this.observer && this.scrollObserverRef?.current) {
      this.observer.unobserve(this.scrollObserverRef.current);
    }
    AppEvents.unsubscribe(this.wapBackButtonEvent);
    window.removeEventListener("scroll", this.handleScroll);
  }

  loadMoreOnScroll = () => {
    if (this.isFiltering) return;
    const { pageNum = 1, totalResultsMatchedCount = 0 } = this.props.filterProductSearchResult || {};
    const nextPage = parseInt(pageNum) + 1;

    if ((nextPage - 1) * resultsPerPage >= +totalResultsMatchedCount) {
      return; // No more products
    }

    this.setState({ isLoadingMore: true }, () => {
      const eventSearchByUserDetailsFn = this.props.eventSearchByUserDetails;
      const data = {
        ...this.dataForEventSearchByUserDetails,
        pageNum: nextPage.toString(),
        eventDateSort: this.state.eventDateSort,
        eventType: this.state.wapEventType != "Todos los eventos" ? this.state.wapEventType : "",
        eventDateStartRange: this.state.startDate || "",
        eventDateEndRange: this.state.endDate || ""
      };
      this.isReorderFn(false);

      eventSearchByUserDetailsFn(data);

      // Optional: wait until props update to turn off loading
      setTimeout(() => this.setState({ isLoadingMore: false }), 1000);
    });
  };

  componentWillReceiveProps(nextProps) {
    const dataRetrive = nextProps && nextProps.filterProductSearchResult;
    const eventDateStartRange = dataRetrive.eventDateStartRange;
    const eventDateEndRange = dataRetrive.eventDateEndRange;
    const totalNoOfRecords = dataRetrive.totalResultsMatchedCount;
    const productSearch = dataRetrive && dataRetrive.events
      ? dataRetrive.events
      : null;

    const {
      firstNameOrNickName,
      lastNameOrPaternalName,
      motherName,
      pageNum,
      eventType
    } = dataRetrive;

    const updateFilter = {
      eventDateEndRange,
      eventDateStartRange,
      firstNameOrNickName,
      lastNameOrPaternalName,
      motherName,
      pageNum,
      eventType,
      resultsPerPage: dataRetrive.resultsPerPage,
    };

    if (JSON.stringify(dataRetrive) !== JSON.stringify(updateFilter)) {
      this.dataForEventSearchByUserDetails = { ...updateFilter };
    } else {
      this.dataForEventSearchByUserDetails = {
        ...this.dataForEventSearchByUserDetails,
        eventDateStartRange,
        eventDateEndRange,
      };
    }

    if (isWebDevice) {
      this.productsArray = this.getProductPerPage(productSearch, nextProps.productPerPageOfPagination);
    } else {
      // * Retrive items shown in cumulative list.
      if (+totalNoOfRecords > resultsPerPage && !this.isReorder) {
        this.updateListOfEvents(productSearch);
        return;
      }
      this.updateListOfEvents(productSearch, true);
    }
  }

  redirectNoStore = () => <Redirect to={commonUtil.getRouteByParameter(applicationRoutes.searchEvent)} />

  // ** For paginator */
  getProductPerPage = (products, noOfProductPerPage) => {
    const productPerPage = [];
    if (products) {
      for (let i = 0; i < products.length; i++) {
        if (i % noOfProductPerPage === 0) {
          productPerPage.push([products[i]]);
        } else {
          productPerPage[productPerPage.length - 1].push(products[i]);
        }
      }
    }
    return productPerPage;
  }

  changeComponentOnBackButtonClick = () =>
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.searchEvent));

  // ** When select all `Todos los eventos` selector WAP */
  resetFilter = () => {
    this.props.cleanSearchByUserDetails();
    const props = this.props || {};
    const filterProductSearchResult = props.filterProductSearchResult || {};
    const firstNameOrNickName = filterProductSearchResult.firstNameOrNickName || '';
    const lastNameOrPaternalName = filterProductSearchResult.lastNameOrPaternalName || '';
    const eventSearchByUserDetailsFn = props.eventSearchByUserDetails || function () { };
    this.filterApplied = false;

    if (this.eventTypeFilter) {
      this.eventTypeFilter.clearSelectedData();
    }

    if (this.eventDateFilter) {
      this.eventDateFilter.clearSelectedData();
    }

    this.calenderDate = '';
    this.firstName = firstNameOrNickName;
    this.lastName = lastNameOrPaternalName;
    this.isReorderFn(true);
    eventSearchByUserDetailsFn({
      ...this.dataForEventSearchByUserDetails,
      eventDateSort: typeOrderProp[0],
    });
  }

  //* * When select one of element of selector Events `Boda, Bautizo, etc` selector. Only WAP */
  filterRecords = (option, type) => {
    if (this.observer && this.scrollObserverRef?.current) {
      this.observer.unobserve(this.scrollObserverRef.current);
    }
    this.isFiltering = true;
    this.props.cleanSearchByUserDetails();

    this.firstName = this.props.filterProductSearchResult.firstNameOrNickName;
    this.lastName = this.props.filterProductSearchResult.lastNameOrPaternalName;
    this.montherName = this.props?.filterProductSearchResult?.motherName;

    const eventSerachData = {};
    eventSerachData.firstNameOrNickName = this.firstName;
    eventSerachData.lastNameOrPaternalName = this.lastName;
    eventSerachData.pageNum = '1';
    eventSerachData.eventDateStartRange =
      type === "eventDate" ? option?.startDate : this.state.startDate || "";
    eventSerachData.eventDateEndRange =
      type === "eventDate" ? option?.endDate : this.state.endDate || "";
    eventSerachData.resultsPerPage = resultsPerPage;
    eventSerachData.eventType = type === "eventType" ? option != "Todos los eventos" ? option : "" : this.state.wapEventType != "Todos los eventos" ? this.state.wapEventType : '' || "";
    eventSerachData.eventDateSort = this.state.eventDateSort || typeOrderProp[0];
    eventSerachData.motherName = this.montherName;

    this.isReorderFn(true);
    this.props.eventSearchByUserDetails(eventSerachData).then().catch((err)=>{
        this.warning.setMessage(err?.errorMessage);
    });

    // 🔹 Update state for filter UI
    if (type === 'eventType') {
      this.setState({
        eventTypeSelectTab: false,
        filterTypeEventOrder: true,
        typeOrder: false,
        wapEventType: option,
        shareModal: false
      });
    } else {
      this.setState({
        eventTypeSelectTab: false,
        filterTypeEventOrder: true,
        typeOrder: false
      });
    }

    // 🔹 After delay (let filtering finish), re-observe and reset isFiltering
    setTimeout(() => {
      this.isFiltering = false;

      if (this.observer && this.scrollObserverRef?.current) {
        this.observer.observe(this.scrollObserverRef.current);
      }
    }, 2000); // Delay depends on your data/rendering speed

    // }
  }

  // ** For paginator when change page*/
  onPageChange = (value) => {
    // TODO: Review this is web only;
    const props = this.props || {};
    const eventSearchByUserDetailsFn = props.eventSearchByUserDetails;

    const filterProductSearchResult = props.filterProductSearchResult || {};
    const firstNameOrNickName = filterProductSearchResult.firstNameOrNickName || '';
    const lastNameOrPaternalName = filterProductSearchResult.lastNameOrPaternalName || '';
    const eventType = filterProductSearchResult.eventType || '';
    const motherName = filterProductSearchResult.motherName || '';

    const eventSerachData = {};
    eventSerachData.firstNameOrNickName = firstNameOrNickName;
    eventSerachData.lastNameOrPaternalName = lastNameOrPaternalName;
    eventSerachData.pageNum = value.toString();
    eventSerachData.eventDateEndRange = this.props.filterProductSearchResult.eventDateEndRange;
    eventSerachData.eventDateStartRange = this.props.filterProductSearchResult.eventDateStartRange;
    eventSerachData.resultsPerPage = resultsPerPage;
    eventSerachData.eventType = eventType;
    eventSerachData.motherName = motherName;
    eventSerachData.eventDateSort = this.state.eventDateSort || typeOrderProp[this.state.updateInternalState ? 1 : 0];
    this.isReorderFn(false);
    eventSearchByUserDetailsFn(eventSerachData);
  }

  // ! Internal state Refactor of listEvents when interact whith btnFilter
  updateListOfEvents = (eventList = [], withFilterFlag) => {
    const eventListResult = (eventList === null) ? [] : eventList;
    this.setState(prevState => (withFilterFlag ? [...eventListResult] : [...prevState.gifthList, ...eventList]));
  }

  // ** Calendar selector */
  renderDateFn = (date) => {
    if (!date) return '';
    const monthsArray = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    return `${monthsArray[+date.substring(5, 7) - 1]} - ${date.substring(0, 4)}`;
  }

  /**
   * Update internal prop class
   * @param { boolean }
   * Flag for update state of class
   */
  isReorderFn = reorder => this.isReorder = reorder;

  /**
   * Retrive key for filter eventDateSort prop for service filter
   * @returns { number } internal state
   */
  typeOrderFn = () => {
    if (!this.props.filterProductSearchResult.eventDateSort && this.flagForBtnFilter) return 1;

    this.setState(prevState => ({
      ...this.state,
      typeOrder: !prevState.typeOrder,
      filterTypeEventOrder: false,
    }));

    return this.state.typeOrder ? 0 : 1;
  }

  updateInternalState = () => {
    this.setState({ ...this.state, updateInternalState: !this.state.updateInternalState });
  }

  enableMonthRangePicker = () => {
    this.setState({ MonthRangePicker: !this.state.MonthRangePicker });
  }
  setStartDateAndEndDate = (date) => {
    if (date && date.start && date.end) {
      // this.setState({btnDisabled: false});
      this.setState({ startDate: date.start, endDate: date.end, startMonthName: date.startMonthName, endMonthName: date.endMonthName })
    }
    else {
      this.setState({ startDate: date.start, endDate: date.end, startMonthName: date.startMonthName, endMonthName: date.endMonthName })
    }
  }

   handleScroll = () => {
    const isWap = commonUtil.getChannel() === "wap"
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (isWap && scrollTop > 1000) {
      this.setState({ showScrollIcon: true });
    } else {
      this.setState({ showScrollIcon: false });
    }
  };

  renderWeb() {
    const props = this.props;
    const filterProductSearchResult = props.filterProductSearchResult || {};
    const eventType = filterProductSearchResult.eventType || '';
    const eventSearchByUserDetailsFn = props.eventSearchByUserDetails || {};

    const paginationInfo = {
      totalNoOfRecords: this.props.filterProductSearchResult.totalResultsMatchedCount,
      recordsPerPage: this.props.filterProductSearchResult.productPerPageOfPagination || resultsPerPage,
      currentPage: this.props.filterProductSearchResult.pageNum,
      totalPages : this.props.filterProductSearchResult.totalPages
    };

    const searchResult = this.productsArray;

    return (
      <div>
        <div className="row" style={{ margin: '0 auto' }}>
          <div>
            {/* <div className="col-md-12 col sm-12">
              {/* <h3 style={{ fontSize: 18, fontWeight: 700 }}>Resultados de la búsqueda</h3> */}
              {/* <div className="col-md-7 col-sm-7 filtersContent"> */}
                {/* <div className="col-md-2 col-sm-2" style={{ float: 'right', width: '270px' }}> */}
                  {
                    // isWebDevice
                    // ? <ReorderListBtn
                    //   dataForEventSearchByUserDetails={this.dataForEventSearchByUserDetails}
                    //   isReorderFn={this.isReorderFn}
                    //   typeOrderFn={this.props.updateStateReorderBtn}
                    //   typeOrderKey={this.props.eventsReorderBtn ? 0 : 1}
                    //   typeOrderProp={typeOrderProp}
                    //   eventDateSort={filterProductSearchResult.eventDateSort}

                    //   updateInternalState={this.updateInternalState}

                    //   eventSearchByUserDetails={eventSearchByUserDetailsFn}
                    //   eventType={eventType}
                    // />
                    // : null
                  }
                {/* </div> */}

              {/* </div> */}
            {/* </div> */} 

            <div className="contentTable extraTable">
              {
                (searchResult.length > 0)
                  ?
                  <EventTable
                    searchResultData={filterProductSearchResult.events && searchResult[this.activeIndex]}
                    // searchResultData={JSONDATA && JSONDATA.events && JSONDATA.events.length > 0 ? JSONDATA.events : []}
                    paginationInfo={paginationInfo}
                    onPageChange={this.onPageChange}
                    resultsPerPage={resultsPerPage}
                    dataForEventSearchByUserDetails={this.dataForEventSearchByUserDetails}
                    isReorderFn={this.isReorderFn}
                    typeOrderFn={this.props.updateStateReorderBtn}
                    typeOrderKey={this.props.eventsReorderBtn ? 0 : 1}
                    typeOrderProp={typeOrderProp}
                    eventDateSort={filterProductSearchResult.eventDateSort}
                    eventCategories={this.props?.eventCategory?.eventConfigurations || []}
                    updateInternalState={this.updateInternalState}
                    totalNoProducts={filterProductSearchResult.totalResultsMatchedCount}
                    eventSearchByUserDetails={eventSearchByUserDetailsFn}
                    eventType={eventType}
                    changeEvetDateSort={this.changeEvetDateSort}
                    eventDateSortState={this.state.eventDateSort}
                  />
                  : null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderWap = () => {
    const props = this.props;
    const filterProductSearchResult = props.filterProductSearchResult || {};
    const eventSearchByUserDetailsFn = props.eventSearchByUserDetails || (function () { });
    const extraData = props.extraData;
    const totalResultsMatchedCount = filterProductSearchResult.totalResultsMatchedCount || 0;
    const pageNum = filterProductSearchResult.pageNum || 0;
    const eventType = filterProductSearchResult.eventType || '';
    const startDate = this.dataForEventSearchByUserDetails.eventDateStartRange;
    const endDate = this.dataForEventSearchByUserDetails.eventDateEndRange;
    const typeOrder = filterProductSearchResult.eventDateSort;
    const eventTypes = [
      { id: 'Todos los eventos', value: 'Todos los eventos', labelResourceId: "Todos los eventos" }, 
      { id: 'Bebé', value: 'Mesa de bebé', labelResourceId: "Mesa de bebé" },
      { id: 'Boda', value: 'Mesa de boda', labelResourceId: "Mesa de boda" },
      { id: 'XV años', value: 'Mesa de XV años', labelResourceId: "Mesa de XV años" },
      { id: 'Bautizo', value: 'Mesa de Bautizo', labelResourceId: "Mesa de Bautizo" },
      { id: 'Cumpleaños', value: 'Mesa de Cumpleaños', labelResourceId: "Mesa de Cumpleaños" },
      { id: 'Open House', value: 'Mesa de Open house', labelResourceId: "Mesa de Open house" },
      { id: 'Mascotas', value: 'Mesa de mascota', labelResourceId: "Mesa de mascota" },
      { id: 'Otras Ceremonias Religiosas', value: 'Mesa de ceremonias religiosas', labelResourceId: "Mesa de ceremonias religiosas" },
      { id: 'Otros', value: 'Mesa de otros eventos', labelResourceId: "Mesa de otros eventos" },
    ];
    // this.props.eventCategory?.eventConfigurations?.map((event) => {
    //   const eventType = {};
    //   eventType.id = event.name;
    //   eventType.value = event.name;
    //   eventType.labelResourceId = event.name;
    //   return eventTypes.push(eventType);
    // });


    const GoToTop = {
      id: 'goToTopOfList',
      type: 'button',
      value: 'Volver arriba',
      autoFocus: false,
      style: 'size-Full',
      iconClass: '',
      onClickHandler: commonUtil.goToTop,
      cssStyle: {
        height: '48px',
        fontFamily: 'robotoRegular',
        color: '#e10098',
        textDecoration: 'underline',
        border: 'none',
        background: 'transparent',
        fontSize: '14px',
      },
    };

    return (
      <div className="row">
        <Warning
          type="error"
          style={{ margin: '0' }}
          text={this.errorMessage}
          ref={warning => this.warning = warning}
        />
        <div className="col-xs-12">
          <h3 style={{ fontSize: 18, fontWeight: 600 }}>Resultados de la búsqueda</h3>
        </div>
        { this.userFirstName  && (<div className="col-xs-12 nombre_header_wap">
          {'Nombre: '}
          <span className='nombre_header_wap_span'>
            {commonUtil.sentenceCase(`${this.userFirstName}`)}
          </span>
        </div>)}
        {this.userLastName && (<div className="col-xs-12 nombre_header_wap">
          {'Primer apellido: '}
          <span className='nombre_header_wap_span'>
            {commonUtil.sentenceCase(`${this.userLastName}`)}
          </span>
        </div>)}
        {this.userMotherName && <div className="col-xs-12 nombre_header_wap">
          {'Segundo apellido: '}
          <span className='nombre_header_wap_span'>
            {commonUtil.sentenceCase(`${this.userMotherName}`)}
          </span>
        </div>}
        {/* <div  className="col-xs-12 range_de_fecha_wap">
          {'Rango de fecha: '}
          <span  className='range_de_fecha_wap_span'>
            {`${this.renderDateFn(startDate)} / ${this.renderDateFn(endDate)}`}
          </span>
        </div> */}
        <div
          className={`${this.state.eventTypeSelectTab
            ? 'col-xs-12 selectorTabContainerLabel'
            : 'col-xs-12 selectorTabContainer'}`}
        >
          <div className='selection_wap_search_container margin-top' onClick={() => this.setState({ shareModal: true })}>
            {(this.state?.wapEventType != "Todos los eventos" && this.state.wapEventType != '') &&
              <div className='eventDate-container-text'>
                  {`${_.find(eventTypes, ['id', this.state?.wapEventType])?.value}`}
              </div>}
            <div className={`${this.state?.wapEventType != "Todos los eventos" && this.state.wapEventType != '' ? "eventDate-Range-text" : "eventDate-container-text"}`}>Todos los eventos</div>
            {/* <span className='selection_wap'>{ this.state.wapEventType ? this.state.wapEventType : "Todos los eventos" } </span>  */}
            {/* <img src={commonUtil.getAssetURL() + '/images/expand_more.svg'} className='selection_wap_img' /> */}
            <span className='selection_wap_img'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z" fill="#767676"/>                
              </svg>
            </span>
          </div>
          <span style={{
            color: "#767676",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: "300",
            lineHeight: "15.6px",
            position: 'relative',
            bottom: '14px'
          }}>Selecciona una opción</span>
          {this.state.shareModal && <GiftListConfigureWapModal
            headerClassName="evnt-modal-header-giftList"
            titleClassName="evnt-modal-title-giftList"
            closeIconClassName="evnt-modal-close-icon-giftList"
            title="Selecciona el tipo de mesa"
            bodyClassName="evnt-modal-body-giftList"
            closeModal={() => this.setState({ shareModal: false })}
          >
            {eventTypes && eventTypes.length > 0 ?
              ([...eventTypes]
                      .sort((a, b) => {
                        if (a.id === this.state.wapEventType) return -1;
                        if (b.id === this.state.wapEventType) return 1;
                        return 0;
                      }).map(
                (option, index) => <div key={index} className="evnt-modal-option-giftList" style={{ color: `${this.state.wapEventType === option.id ? "#C0C0C0" : ""}` }} onClick={() => {
                  this.setState({ shareModal: false });
                  this.filterRecords(option.id, 'eventType')
                }}> {option.value}</div>)) : null}

          </GiftListConfigureWapModal>}
          <div style={{ width: '100%' }}>
            <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '18px', color: " rgba(0, 0, 0, 1)" }}>
              Fecha estimada del evento
            </p>


            <div className='selection_wap_search_container' onClick={this.enableMonthRangePicker}>
                 {(this.state.startMonthName && this.state.endMonthName ) &&
              <div className='eventDate-container-text'>
               {`${this.state?.startMonthName} / ${this.state?.endMonthName}`}
              </div>}
            <div className={`${this.state.startMonthName && this.state.endMonthName ? "eventDate-Range-text" : "eventDate-container-text"}`}>Rango de fecha del evento</div>
              {/* <div className={"eventDate-container-text"}>{this.state.startMonthName && this.state.endMonthName ? `${this.state?.startMonthName} / ${this.state?.endMonthName}` : ""}</div> */}
              <div className='eventDate-container-img'>
                <img src={commonUtil.getAssetURL() + '/images/date_range.svg'} />
              </div>
            </div>
            {this.state.MonthRangePicker && <GiftListConfigureWapModal
              headerClassName="evnt-modal-header-giftList"
              titleClassName="evnt-modal-title-giftList"
              closeIconClassName="evnt-modal-close-icon-giftList"
              title="Rango de fecha del evento"
              bodyClassName="evnt-modal-body-giftList"
              closeModal={() => this.setState({ MonthRangePicker: false })}
            >
              <MonthRangePicker startDate={this.state.startDate} endDate={this.state.endDate} setStartDateAndEndDate={this.setStartDateAndEndDate} enableMonthRangePicker={this.enableMonthRangePicker} isWapSearch={true} submit={this.filterRecords} />
            </GiftListConfigureWapModal>}

          </div>
        </div>

        <div className="contentTable">
          {/* { */}
          {extraData.length > 0
            ?
            <>
              <EventTable
                //  searchResultData={JSONDATA && JSONDATA.events && JSONDATA.events.length > 0 ? JSONDATA.events : []}
                dataForEventSearchByUserDetails={this.dataForEventSearchByUserDetails}
                cleanSearchByUserDetails={this.props.cleanSearchByUserDetails}
                eventSearchByUserDetails={eventSearchByUserDetailsFn}
                searchResultData={extraData}
                eventType={eventType}
                typeOrderFn={this.typeOrderFn}
                filterTypeEventOrder={this.state.filterTypeEventOrder}
                isReorderFn={this.isReorderFn}
                typeOrderKey={this.state.typeOrder ? 1 : 0}
                typeOrder={typeOrder}
                eventCategories={this.props?.eventCategory?.eventConfigurations || []}
                typeOrderProp={typeOrderProp}
                paginationInfo={{
                  totalNoOfRecords: totalResultsMatchedCount,
                  currentPage: filterProductSearchResult.pageNum,
                }}
                resultsPerPage={resultsPerPage}
                totalNoProducts={filterProductSearchResult.totalResultsMatchedCount}
              />
              <div ref={this.scrollObserverRef} style={{ height: '20px' }}></div>
                {this.state.showScrollIcon && <div className='go-top-button'>
                    <img src={commonUtil.getAssetURL() + "/images/arrow_upward.svg"}onClick={commonUtil.goToTop} />
                </div>}
            </>
            : null}
          {/* } */}
        </div>
        {+totalResultsMatchedCount > resultsPerPage ?
          <div
            className="col-xs-12 footerNav footerNavTableResults"
            style={{
              paddingRight: '15px',
              paddingLeft: '15px',
              display: 'flex',
              gap: '14px',
            }}
          >
            {/* {
              !((pageNum * resultsPerPage) >= +totalResultsMatchedCount) && (
                <NextArrowWap
                  eventDateSort={typeOrderProp[this.state.typeOrder ? 1 : 0]}
                  eventSearchByUserDetails={eventSearchByUserDetailsFn}
                  filterProductSearchResult={filterProductSearchResult}
                  resultsPerPage={resultsPerPage}
                  isReorderFn={this.isReorderFn}
                />
              )
            } */}

            {/* {
              <div>
                <InputButton buttonAttr={GoToTop} />
              </div>
            } */}
          </div> : null}
      </div>
    );
  }

  render() {
    return (
      <div>
        <ApplyCSS pageName={pageName} />
        {(!isWebDevice) ? this.renderWap() : this.renderWeb()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filterProductSearchResult: state.searchResult.filterProductSearchResult,
  productPerPageOfPagination: state.searchResult.productPerPageOfPagination,
  extraData: state.searchResult.extraData,
  lables: state.labels.data,
  eventCategory: state.eventcategory.data,
});

const matchDispatchToProps = dispatch => bindActionCreators({
  eventSearchByUserDetails,
  addAllEventSearchByUserDetails,
  cleanSearchByUserDetails,
}, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(SearchResult);
